import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { messages } from '../../../../../messages';
export const SubmitButton = ({
  formId,
  nextButtonOnClick,
  nextButtonAppearance,
  isNextButtonDisabled,
  isSubmissionLoading,
  nextButtonText,
  testId
}) => {
  const {
    formatMessage
  } = useIntl();
  const handleOnClick = async event => {
    event.preventDefault();
    const form = document.getElementById(formId || '');
    if (form) {
      await new Promise(resolve => {
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        form === null || form === void 0 ? void 0 : form.addEventListener('submit', resolve, {
          once: true
        });
        form.requestSubmit();
      });
    }

    // nextButtonOnClick needs to come after form.submit() to ensure the form is submitted before the next step is triggered
    nextButtonOnClick === null || nextButtonOnClick === void 0 ? void 0 : nextButtonOnClick();
  };
  return /*#__PURE__*/React.createElement(Button, {
    testId: `${testId}-footer-submit-button`,
    onClick: handleOnClick,
    appearance: nextButtonAppearance || 'primary',
    form: formId,
    type: "submit",
    isDisabled: isNextButtonDisabled || isSubmissionLoading,
    isLoading: isSubmissionLoading
  }, nextButtonText || formatMessage(messages.defaultNextButtonText));
};